import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Brain, Camera, Film } from 'lucide-react';
import '../styles/loadingpages.css';
import { motion } from 'framer-motion';
import { baseUrl } from '../config';



const CinematicAILoading = () => {
  const [loadingText, setLoadingText] = useState('Analyzing Film Patterns...');
  const [progress, setProgress] = useState(0);
  
  const loadingPhrases = useMemo(() => [
    'Loading AI Systems...',
    'Processing Visual Data...',
    'Analyzing Film Patterns...',
    'Syncing Neural Networks...',
    'Optimizing Performance...',
    'Finalizing Setup...'
  ], []);

  const updateLoadingText = useCallback(() => {
    setLoadingText(prev => {
      const currentIndex = loadingPhrases.indexOf(prev);
      return loadingPhrases[(currentIndex + 1) % loadingPhrases.length];
    });
  }, [loadingPhrases]);

  const updateProgress = useCallback(() => {
    setProgress(prev => (prev < 100 ? prev + 1 : prev));
  }, []);

  useEffect(() => {
    const textInterval = setInterval(updateLoadingText, 2000);
    const progressInterval = setInterval(updateProgress, 50);

    return () => {
      clearInterval(textInterval);
      clearInterval(progressInterval);
    };
  }, [updateLoadingText, updateProgress]);

  return (
    <div className="cinematic-loading">
      {/* Animated Background Circles */}
      <div className="background-animation">
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
      </div>

      {/* Logo Section */}
      <div className="logo-section">
        <Brain className="icon" />
        <h1 className="text-blue-500">Producer Buddy</h1>
      </div>

      {/* Loading Animation */}
      <div className="space-y-8">
        {/* Central Loading Circle */}
        <div className="relative w-32 h-32 mx-auto">
          <div className="flex justify-center items-center p-4">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
          </div>
        </div>
      </div>

      {/* Status Text */}
      <h2 className="status-text">{loadingText}</h2>
      <div className="status-text">{progress}% Complete</div>

      {/* Progress Bar */}
      <div className="progress-bar">
        <div
          className="progress-bar-inner"
          style={{ width: `${progress}%`, transition: 'width 0.1s ease-in-out' }}
        />
      </div>

      {/* Status Indicators */}
      <div className="status-indicators">
        <div className={`indicator ${progress >= 25 ? 'active' : ''}`}>AI Active</div>
        <div className={`indicator ${progress >= 50 ? 'active' : ''}`}>Rendering</div>
        <div className={`indicator ${progress >= 75 ? 'active' : ''}`}>Processing</div>
        <div className={`indicator ${progress >= 100 ? 'active' : ''}`}>Complete</div>
      </div>
    </div>
  );
};

export default CinematicAILoading;

